const Plugin = require("../common/Plugin");
const DynAppsController = require("./DynAppsController");
const DynAppsLaunchDialog = require("./DynAppsLaunchDialog");
const TimeSelectorDialog = require("./TimeSelectorDialog");

/**
 * @class
 * @constructor
 */
function DynAppsPlugin(additionalRenderers) {
    const self = this;

    this.start = function() {
        // Register view with controller
        const timeSelectorDialog = new TimeSelectorDialog();
        const launchDialog = new DynAppsLaunchDialog();
        const controller = new DynAppsController(launchDialog, timeSelectorDialog, additionalRenderers);
        CudaLaunch.controllers.RootController.addDelegatingRenderingController(controller);

        self.registerController(controller);
    };
}

DynAppsPlugin.prototype = Plugin;

module.exports = DynAppsPlugin;


//////////////////
// WEBPACK FOOTER
// ./dyn_apps/DynAppsPlugin.js
// module id = 111
// module chunks = 0